module.exports = __webpack_public_path__ + "img/img20.4836d929.svg";